export default __webpack_public_path__ + "media/counselling-hero-bg.a025c6ec.png";